import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
@Component({
  selector: 'app-generic-fetching-records',
  templateUrl: './generic-fetching-records.component.html',
  styleUrls: ['./generic-fetching-records.component.scss']
})
export class GenericFetchingRecordsComponent implements OnInit {
  @Input() stillLoading: boolean = false;
  @Input() dataList: any = [];
  @Input() notFoundMessage: any = '';

  @Output()
  sendAction = new EventEmitter()
  constructor(private toasterService: ToasterService,
    public webService: WebServiceService) { }
  ngOnInit() {
    if (this.notFoundMessage == '' || this.notFoundMessage == undefined) {
      this.notFoundMessage = 'No Data Found';
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4173005015/src/src/app/generic-ui-components/generic-fetching-records/generic-fetching-records.component.ts